import { Close } from "@mui/icons-material";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    styled,
    TextField,
    Grid,
    MenuItem,
    FormControl,
    Select,
    Dialog as MuiDialog,
    DialogContentText,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";

const StyledHeaderTitle = styled(DialogTitle)(({ theme }) => ({
    background: theme.palette.primary.main,
    color: "#fff",
    position: "relative",
    "& button": {
        position: "absolute",
        right: "15px",
        top: "15px",
        color: "#fff",
    },
}));

const FlexContent = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    fontSize: "17px",
    marginBottom: "10px",
    alignItems: "flex-start",
}));

const FlexInnerTitle = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    minWidth: "210px",
    maxWidth: "320px",
    fontWeight: "600",
}));

const Values = styled("div")(({ theme }) => ({
    marginLeft: "15px",
    fontWeight: "500",
    color: theme.palette.primary.dark,
    "& input": {
        padding: "10px",
        width: "250px",
    },
    "& .MuiSelect-select": {
        padding: "10px",
    },
    "& button": {
        padding: "11px !important",
        minWidth: "40px",
    },
}));

const states = [
    { id: 1, name: "NSW" },
    { id: 2, name: "VIC" },
    { id: 3, name: "QLD" },
    { id: 4, name: "WA" },
    { id: 5, name: "SA" },
    { id: 6, name: "TAS" },
    { id: 7, name: "NT" },
    { id: 8, name: "ACT" },
];

// Added Countries List
const countries = [
    { id: "AU", name: "Australia" },
    { id: "NZ", name: "New Zealand" }, // Corrected spelling from "New Zeland"
];

const Edit3PLDialog = (props) => {
    const [dialogDetails, setDialogDetails] = useState({
        open: true,
        success: false,
        deliveryFirstName: (props.viewDetails && props.viewDetails[0].deliveryDetail3pl.deliveryFirstName3pl) || "",
        deliveryLastName: (props.viewDetails && props.viewDetails[0].deliveryDetail3pl.deliveryLastName3pl) || "",
        deliveryPhone: (props.viewDetails && props.viewDetails[0].deliveryDetail3pl.deliveryPhone3pl) || "",
        deliveryStreet: (props.viewDetails && props.viewDetails[0].deliveryDetail3pl.deliveryStreet3pl) || "",
        deliveryCity: (props.viewDetails && props.viewDetails[0].deliveryDetail3pl.deliveryCity3pl) || "",
        deliveryPostCode: (props.viewDetails && props.viewDetails[0].deliveryDetail3pl.deliveryPostCode3pl) || "",
        deliveryState: (props.viewDetails && props.viewDetails[0].deliveryDetail3pl.deliveryState3pl) || "",
        deliveryCountry: (props.viewDetails && props.viewDetails[0].deliveryDetail3pl.deliveryCountry3pl) || "",
    });

    const [showConfirmDialog, setShowConfirmDialog] = useState(false);

    const handleFirstNameChange = (event) => {
        setDialogDetails({
            ...dialogDetails,
            deliveryFirstName: event.target.value,
        });
    };

    const handleLastNameChange = (event) => {
        setDialogDetails({
            ...dialogDetails,
            deliveryLastName: event.target.value,
        });
    };

    const handlePhoneChange = (event) => {
        setDialogDetails({
            ...dialogDetails,
            deliveryPhone: event.target.value,
        });
    };

    const handleDeliveryAddressChange = (event) => {
        setDialogDetails({
            ...dialogDetails,
            deliveryStreet: event.target.value,
        });
    };

    const handleDeliveryAddressChange1 = (event) => {
        setDialogDetails({
            ...dialogDetails,
            deliveryCity: event.target.value,
        });
    };

    const handleDeliveryAddressChange2 = (event) => {
        setDialogDetails({
            ...dialogDetails,
            deliveryPostCode: event.target.value,
        });
    };

    // Country Handler
    const handleDeliveryCountryChange = (event) => {
        const selectedCountry = event.target.value;
        setDialogDetails((prevDialogDetails) => ({
            ...prevDialogDetails,
            deliveryCountry: selectedCountry,
        }));
    };

    const handleDeliveryAddressChange3 = (event) => {
        const selectedState = event.target.value;
        setDialogDetails((prevDialogDetails) => ({
            ...prevDialogDetails,
            deliveryState: selectedState,
        }));
    };

    useEffect(() => {
        props.sendReset(dialogDetails);
    }, [dialogDetails]);

    const handleClose = () => {
        setDialogDetails({
            ...dialogDetails,
            open: false,
        });
    };

    const handleEditClick = () => {
        setShowConfirmDialog(true);
    };

    const handleConfirmEdit = () => {
        setShowConfirmDialog(false);
        setDialogDetails({
            ...dialogDetails,
            open: false,
            success: true,
        });
    };

    const handleCancelEdit = () => {
        setShowConfirmDialog(false);
    };

    return (
        <div>
            {/* Main Edit Dialog */}
            <Dialog
                open={dialogDetails.open}
                onClose={handleClose}
                maxWidth="sm"
                fullWidth
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <StyledHeaderTitle id="alert-dialog-title">
                    Edit 3PL Delivery Details
                    <IconButton onClick={handleClose}>
                        <Close />
                    </IconButton>
                </StyledHeaderTitle>
                <DialogContent>
                    <Box p={3} sx={{ width: "100%" }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={8}>
                                <FlexContent>
                                    <FlexInnerTitle>
                                        <span>First Name</span> <span> : </span>
                                    </FlexInnerTitle>
                                    <Values>
                                        <TextField
                                            id="deliveryFirstName"
                                            label=""
                                            variant="standard"
                                            value={dialogDetails.deliveryFirstName}
                                            onChange={handleFirstNameChange}
                                        />
                                    </Values>
                                </FlexContent>
                                <FlexContent>
                                    <FlexInnerTitle>
                                        <span>Last Name</span> <span> : </span>
                                    </FlexInnerTitle>
                                    <Values>
                                        <TextField
                                            id="deliveryLastName"
                                            label=""
                                            variant="standard"
                                            value={dialogDetails.deliveryLastName}
                                            onChange={handleLastNameChange}
                                        />
                                    </Values>
                                </FlexContent>
                                <FlexContent>
                                    <FlexInnerTitle>
                                        <span>Phone</span> <span> : </span>
                                    </FlexInnerTitle>
                                    <Values>
                                        <TextField
                                            id="deliveryPhone"
                                            label=""
                                            variant="standard"
                                            value={dialogDetails.deliveryPhone}
                                            onChange={handlePhoneChange}
                                        />
                                    </Values>
                                </FlexContent>
                                <FlexContent>
                                    <FlexInnerTitle>
                                        <span>Address</span> <span> : </span>
                                    </FlexInnerTitle>
                                    <Values>
                                        <TextField
                                            id="deliveryStreet"
                                            label=""
                                            variant="standard"
                                            value={dialogDetails.deliveryStreet}
                                            onChange={handleDeliveryAddressChange}
                                        />
                                    </Values>
                                </FlexContent>
                                <FlexContent>
                                    <FlexInnerTitle>
                                        <span>City</span> <span> : </span>
                                    </FlexInnerTitle>
                                    <Values>
                                        <TextField
                                            id="deliveryCity"
                                            label=""
                                            variant="standard"
                                            value={dialogDetails.deliveryCity}
                                            onChange={handleDeliveryAddressChange1}
                                        />
                                    </Values>
                                </FlexContent>
                                <FlexContent>
                                    <FlexInnerTitle>
                                        <span>State</span> <span> : </span>
                                    </FlexInnerTitle>
                                    <Values>
                                        <FormControl style={{ width: "260px", marginBottom: "10px" }}>
                                            <Select
                                                variant="standard"
                                                name="deliveryState"
                                                value={dialogDetails.deliveryState}
                                                onChange={handleDeliveryAddressChange3}
                                            >
                                                <MenuItem value={""}>
                                                    <em>Select state</em>
                                                </MenuItem>
                                                {states.length > 0 &&
                                                    states.map((state) => (
                                                        <MenuItem
                                                            value={state.name}
                                                            key={state.id}
                                                        >
                                                            {state.name}
                                                        </MenuItem>
                                                    ))}
                                            </Select>
                                        </FormControl>
                                    </Values>
                                </FlexContent>
                                <FlexContent>
                                    <FlexInnerTitle>
                                        <span>Post Code</span> <span> : </span>
                                    </FlexInnerTitle>
                                    <Values>
                                        <TextField
                                            id="deliveryPostCode"
                                            label=""
                                            variant="standard"
                                            value={dialogDetails.deliveryPostCode}
                                            onChange={handleDeliveryAddressChange2}
                                        />
                                    </Values>
                                </FlexContent>
                                
                                {/* UPDATED COUNTRY DROPDOWN */}
                                <FlexContent>
                                    <FlexInnerTitle>
                                        <span>Country</span> <span> : </span>
                                    </FlexInnerTitle>
                                    <Values>
                                        <FormControl style={{ width: "260px", marginBottom: "10px" }}>
                                            <Select
                                                variant="standard"
                                                name="deliveryCountry"
                                                value={dialogDetails.deliveryCountry}
                                                onChange={handleDeliveryCountryChange}
                                            >
                                                <MenuItem value={""}>
                                                    <em>Select country</em>
                                                </MenuItem>
                                                {countries.map((country) => (
                                                    <MenuItem
                                                        value={country.id}
                                                        key={country.id}
                                                    >
                                                        {country.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Values>
                                </FlexContent>

                            </Grid>
                        </Grid>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ margin: "5px 10px", display: "flex", alignItems: "center" }}>
                    <Button size="small" onClick={handleClose} color="primary" variant="outlined" autoFocus>
                        Cancel
                    </Button>
                    <Button
                        size="small"
                        variant="contained"
                        onClick={handleEditClick}
                    >
                        Edit
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Confirmation Dialog */}
            <MuiDialog
                open={showConfirmDialog}
                onClose={handleCancelEdit}
                aria-labelledby="confirm-dialog-title"
                aria-describedby="confirm-dialog-description"
            >
                <DialogTitle id="confirm-dialog-title">
                    Confirm Edit
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="confirm-dialog-description">
                        Are you sure you want to edit?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelEdit} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleConfirmEdit} color="primary" autoFocus>
                        Yes
                    </Button>
                </DialogActions>
            </MuiDialog>
        </div>
    );
};

export default Edit3PLDialog;